import { render, staticRenderFns } from "./payment-page.vue?vue&type=template&id=704fc8db"
import script from "./payment-page.vue?vue&type=script&lang=ts"
export * from "./payment-page.vue?vue&type=script&lang=ts"
import style0 from "./payment-page.vue?vue&type=style&index=0&id=704fc8db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
